import React, { useState } from "react";
import { Button, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";

export default function ImportarAcoesCotacao() {
  const [loading, setLoading] = useState(false);

  const props = {
    name: "file",
    action: `${process.env.REACT_APP_API_RB}/acoes_csv/importar-acoes-cotacao`,
    // headers: { "Content-Type": "multipart/form-data" },
    showUploadList: false,
    beforeUpload: () => setLoading(true),
    onChange(info) {
      if (info.file.status === "done") {
        message.success("Arquivo enviado com sucesso!");
        setLoading(false);
      } else if (info.file.status === "error") {
        message.error("Falha ao enviar arquivo.");
        setLoading(false);
      }
    },
  };

  return (
    <div style={{ padding: 24 }}>
      <h2>Importar Ações Cotação</h2>
      <Upload {...props} accept=".csv">
        <Button icon={<UploadOutlined />} loading={loading}>
          Selecionar arquivo CSV
        </Button>
      </Upload>
      <div style={{ marginTop: 16 }}>
        <b>Exemplo de CSV:</b>
        <pre style={{ background: "#f5f5f5", padding: 8 }}>
acoes_id;acoes_data;acoes_abertura;acoes_min;acoes_max;acoes_med;acoes_valor;acoes_porcentagem;acoes_compra;acoes_venda;acoes_negocios;acoes_qtd_titulos
        </pre>
      </div>
    </div>
  );
}
